
<medical-order-scann-control
  *ngIf="appointment"
  [readOnly]="readonly"
  [canSelect]="canExtractProcedures"
  [medicalorderId]="appointment.MedicalOrderEdit.MedicalOrder.Id"
  [medicalsOrderScann]="scanns"
  (onMecicalOrderScannChange)="onMecicalOrderScannChange($event)"
  (onMecicalOrderSelected)="onMecicalOrderSelected($event)"
></medical-order-scann-control>
